const BODY = {
  tshirt: "M210 70 Q300 120 390 70 L500 120 L560 230 L480 265 L460 230 L460 540 Q300 560 140 540 L140 230 L120 265 L40 230 L100 120 Z",
  longsleeve: "M210 70 Q300 120 390 70 L490 115 L575 450 L515 470 L460 260 L460 540 Q300 560 140 540 L140 260 L85 470 L25 450 L110 115 Z",
  hoodie: "M215 85 Q230 20 300 15 Q370 20 385 85 L495 125 L575 450 L515 470 L462 270 L462 545 Q300 565 138 545 L138 270 L85 470 L25 450 L105 125 Z",
  hat: "M110 380 Q110 150 300 140 Q490 150 490 380 Z M70 380 Q300 330 530 380 Q545 445 300 432 Q55 445 70 380 Z",
  mug: "M150 140 L430 140 L430 480 Q430 510 400 510 L180 510 Q150 510 150 480 Z M430 210 Q530 210 530 320 Q530 420 430 420 L430 380 Q490 380 490 320 Q490 250 430 250 Z",
  sticker: "M150 110 H450 Q490 110 490 150 V450 Q490 490 450 490 H150 Q110 490 110 450 V150 Q110 110 150 110 Z",
};

const DETAILS = {
  tshirt: { front: "M210 70 Q300 140 390 70", back: "M210 70 Q300 92 390 70" },
  longsleeve: { front: "M210 70 Q300 140 390 70", back: "M210 70 Q300 92 390 70" },
  hoodie: { front: "M240 90 Q300 160 360 90 M290 130 L285 220 M310 130 L315 220 M200 400 L400 400 L430 500 L170 500 Z", back: "M230 90 Q300 120 370 90" },
  hat: { front: "M300 140 L300 380 M200 160 Q170 260 175 375 M400 160 Q430 260 425 375" },
  mug: { front: "" },
  sticker: { front: "" },
};

export const TEMPLATE_OPTIONS = [
  ["tshirt", "T-Shirt"], ["longsleeve", "Long Sleeve"], ["hoodie", "Hoodie"], ["hat", "Hat"], ["mug", "Mug"], ["sticker", "Sticker"],
];

const isDark = (hex) => {
  const h = (hex || "#000").replace("#", "");
  const n = parseInt(h.length === 3 ? h.split("").map((c) => c + c).join("") : h, 16);
  return ((n >> 16) & 255) * 0.299 + ((n >> 8) & 255) * 0.587 + (n & 255) * 0.114 < 140;
};

export const templateSvg = (template, side, hex) => {
  const body = BODY[template] || BODY.tshirt;
  const detail = (DETAILS[template] || {})[side] || "";
  const line = isDark(hex) ? "rgba(255,255,255,0.22)" : "rgba(0,0,0,0.25)";
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 600"><defs><linearGradient id="g" x1="0" x2="1"><stop offset="0" stop-color="#000" stop-opacity="0.28"/><stop offset="0.5" stop-color="#fff" stop-opacity="0.06"/><stop offset="1" stop-color="#000" stop-opacity="0.28"/></linearGradient></defs><path d="${body}" fill="${hex}" stroke="rgba(0,0,0,0.45)" stroke-width="3" fill-rule="nonzero"/><path d="${body}" fill="url(#g)"/>${detail ? `<path d="${detail}" fill="none" stroke="${line}" stroke-width="4" stroke-linecap="round"/>` : ""}</svg>`;
};

export const templateDataUrl = (template, side, hex) => `data:image/svg+xml;charset=utf-8,${encodeURIComponent(templateSvg(template, side, hex))}`;
